/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {TemplateAst} from '../template_ast';

import {CompileNode} from './compile_element';

export class CompileBinding {
  constructor(public node: CompileNode, public sourceAst: TemplateAst) {}
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
